import * as THREE from 'three'
import { EventDispatcher } from '@/shared/events/EventDispatcher'

/**
 * 点云树节点基类
 * @description 定义点云树节点的基本接口和行为
 */
export class PointCloudTreeNode extends EventDispatcher {
  /** 是否需要更新变换矩阵 */
  needsTransformUpdate = true

  /**
   * 获取子节点
   * @returns 子节点数组
   */
  getChildren(): any[] {
    throw new Error('override function')
  }

  /**
   * 获取包围盒
   * @returns THREE.js 包围盒对象
   */
  getBoundingBox(): THREE.Box3 {
    throw new Error('override function')
  }

  /**
   * 检查节点是否已加载
   * @returns 是否已加载
   */
  isLoaded(): boolean {
    throw new Error('override function')
  }

  /**
   * 检查是否为几何节点
   * @returns 是否为几何节点
   */
  isGeometryNode(): boolean {
    throw new Error('override function')
  }

  /**
   * 检查是否为树节点
   * @returns 是否为树节点
   */
  isTreeNode(): boolean {
    throw new Error('override function')
  }

  /**
   * 获取节点在树中的层级
   * @returns 层级值
   */
  getLevel(): number {
    throw new Error('override function')
  }

  /**
   * 获取包围球
   * @returns THREE.js 包围球对象
   */
  getBoundingSphere(): THREE.Sphere {
    throw new Error('override function')
  }
}

/**
 * 点云树基类
 * @description 继承自 THREE.Object3D，提供点云树的基本结构
 */
export class PointCloudTree extends THREE.Object3D<any> {
  /** 根节点 */
  root: any

  /**
   * 检查点云树是否已初始化
   * @returns 是否已初始化（根节点不为 null）
   */
  initialized(): boolean {
    return this.root !== null
  }
}
